export class FeedBack{
    Subject:any;
    Description:any;
    Severity:any;
    UserName:any;
    Role:any;
    Attechment:File;
    Center:any;
    ErrorPage:any;
}